import gameNames from '../../hub/data/GameIds';

export const GAME_ID = gameNames.SLOPPY_SCROLLS;

export const ITEMS_IN_ROUND = 5;
export const ITEMS_IN_35_ROUND = 3;
export const ITEMS_TO_MASTER = 4;
export const ITEMS_TO_MASTER_35 = 2;
export const ONBOARDING_CORRECT_ANSWER_INDEX = 3;
export const G35_LEVELS_START_INDEX = 6;

// Enum for consistency in windowType
export const ActivityWindowType = {
  PROGRESS: 'progress',
  INTRO: 'intro',
  LEVEL: 'level',
  LOADING: 'loading',
};

// Enum for which portion of a level should show
export const LevelStage = {
  ONBOARDING: 'onboarding',
  STANDARD: 'standard',
};

// Enum for what should show at the bottom of the screen:
// DoneButton (DONE), checkmark (CORRECT),
// x (INCORRECT), etc.
export const FeedbackDisplay = {
  SUBMIT: 'submit',
  DONE: 'done',
  CORRECT: 'correct',
  INCORRECT: 'incorrect',
};

// Enum for various types of feedback that can be somehow displayed/given to user
// The cases depend on whether the passage has any inconsistency mistakes and whether student
// correctly identified the mistake (if any)
export const FEEDBACK_TYPES = {
  NONE: 'no_feedback',
  CORRECT_IDENTIFIED_NO_MISTAKES: 'correctly_identified_no_mistakes',
  CORRECT_MISTAKE_FOUND: 'correctly_identified_a_mistake_in_passage',
  INCORRECT_DID_NOT_FIND_MISTAKE: 'failed_to_identify_a_mistake_in_passage',
  INCORRECT_FOUND_MISTAKE_WHEN_NONE: 'identified_a_mistake_when_none_exists',
  INCORRECT_REVEAL: 'reveal_the_correct_responses',
};
